/* eslint-disable import/no-extraneous-dependencies */
import isEmpty from 'lodash-es/isEmpty';

export const ALLOWED_RECRUITER_STATUSES = [
  'TO_MEET',
  'MET_VALIDATION',
  'SEND_PROMISE_OF_EMPLOYMENT',
  'HIRED',
  'VALIDATED',
  'RECOMMENDED',
  'KEEP_IN_TOUCH'
];
export const COLLABORATOR_FIELDS = [
  'aspirations',
  'skillUuids',
  'contactForOpportunities',
  'lastConnectionDate',
  'availability',
  'emailOpportunities',
  'experiences',
  'formations',
  'languages',
  'motivation',
  'bookmarkedJobOffersUuids',
  'attachments',
  'contractTypePreferences',
  'salaryExpectation',
  'recommendations'
];
export const MAX_SIZE = 50;
export const DEFAULT_SIZE = 10;
export const DEFAULT_SORT = 'matching-desc';

export const TEST_WORKSPACE_ENTITY_UUID = 'entity_1743091319_d0743410-0b24-11f0-9d34-d36345198076';

export const isWebtalesUser = email => typeof email === 'string' && email.endsWith('@webtales.fr');

export const computeCompletion = (prospect, profileFieldConfig) => {
  if (!prospect || !profileFieldConfig) return 0;

  let totalWeight = 0;
  let completedWeight = 0;

  for (const field of profileFieldConfig) {
    const { collaboratorField, weight, multi, minForFullWeight } = field;

    const value = prospect[collaboratorField];

    totalWeight += weight;

    if (multi) {
      const count = Array.isArray(value) && !isEmpty(value) ? value.length : 0;
      if (count >= (minForFullWeight || 1)) {
        completedWeight += weight;
      }
    } else if (typeof value === 'boolean' ? value : !isEmpty(value)) {
      completedWeight += weight;
    }
  }

  return totalWeight === 0 ? 0 : Math.round((completedWeight / totalWeight) * 100);
};
